const getUrl = window.location;
export const BASE_URL =
  getUrl.protocol + '//' + getUrl.host + '/' === 'http://localhost:3005/'
    ? 'http://localhost:3001'
    : getUrl.protocol + '//' + getUrl.host;
